import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    Input
} from '@angular/core';

import { UmbracoBlockConfiguration } from '../../models/umbraco-blocks.types';
import { HighlightTextPipe } from '../../pipes/highlight-text.pipe';

@Component({
    selector: 'nw-page-header-block',
    templateUrl: './page-header-block.component.html',
    styleUrl: './page-header-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [HighlightTextPipe]
})
export class PageHeaderBlockComponent {
    @Input() logo?: string;
    @Input({ transform: booleanAttribute }) islandingpage: boolean = false;
    @Input() heading!: string;
    @Input() subheading?: string;
    @Input() calltoaction?: UmbracoBlockConfiguration.Button;
}
